import { useParams } from "react-router-dom";
import { users } from "../../fake-db/users";

const Profile = () => {
  const { id } = useParams();
  const user = users.find((item) => {
    return `${item.id}` === `${id}`;
  });

  return (
    <div className="flex flex-col justify-center items-center w-full">
      <img
        src={user?.avatar}
        alt={user?.name}
        className="w-20 h-20 rounded-full object-cover object-center mb-3"
      />
      <h4 className="text-xl text-slate-600 font-medium">{user?.name}</h4>
      <div className="flex gap-2 items-center">
        <p className="text-base text-gray-500">{user?.profession}</p>
      </div>
      <div className="flex flex-col gap-2 py-2">
        <div className="">
          <h5 className="font-normal text-base text-gray-400 uppercasep py-3">
            About
          </h5>
          <div className="flex gap-2">
            <p className="text-base text-gray-500">{user?.bio}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
